var savedDiceFiles = window.savedDiceFiles = window.savedDiceFiles || {};

(function () {
  var FACE_ORDER = ['d20', 'd12', 'd10', 'd00', 'd8', 'd6', 'd4'];
  var FACE_LABELS = {
    d20: 'D20',
    d12: 'D12',
    d10: 'D10',
    d00: 'D%',
    d8: 'D8',
    d6: 'D6',
    d4: 'D4'
  };
  var FACE_DESCRIPTIONS = {
    d20: 'Includes custom crit engraving when you add one to a kit.',
    d12: 'Great for rare loadouts and Daggerheart-style duality builds.',
    d10: 'Numbered 0-9.',
    d00: 'Percentile d10 (00-90).',
    d8: 'Single d8.',
    d6: 'Stock up here if your game eats d6s.',
    d4: 'Single d4.'
  };
  var D20_LAYOUT = {
    mockupX: 246,
    mockupY: 212,
    mockupXAlign: 132,
    mockupYAlign: 130,
    mockupTextXAlign: 132,
    mockupTextYAlign: 145,
    custTextMockupX: 246,
    custTextMockupY: 212
  };

  function escapeHtml(value) {
    return String(value == null ? '' : value).replace(/[&<>"']/g, function (char) {
      return {
        '&': '&amp;',
        '<': '&lt;',
        '>': '&gt;',
        '"': '&quot;',
        "'": '&#39;'
      }[char];
    });
  }

  function toCents(value) {
    if (typeof value === 'number') {
      return value;
    }

    var numeric = parseFloat(value || '0');
    return Math.round(numeric * 100);
  }

  function formatMoney(cents) {
    return '$' + (cents / 100).toFixed(2);
  }

  function slugify(value) {
    return String(value || '')
      .toLowerCase()
      .replace(/[^a-z0-9]+/g, '-')
      .replace(/^-+|-+$/g, '');
  }

  function createEmptyCounts() {
    var counts = {};
    FACE_ORDER.forEach(function (face) {
      counts[face] = 0;
    });
    return counts;
  }

  function createEmptySlotSelections() {
    var selections = {};
    FACE_ORDER.forEach(function (face) {
      selections[face] = [];
    });
    return selections;
  }

  var STORAGE_KEY = 'shinymath_kit_builder_state';

  function saveStateToStorage(state) {
    try {
      var customizerChoices = (state.customizers || []).map(function (c) {
        if (!c || !c.isConfigured) return null;
        if (c.engravingChoice) return { type: 'stock', key: c.engravingChoice };
        if (c.customTextValue) return { type: 'text', text: c.customTextValue, font: c.customFontValue || '' };
        return { type: 'image' }; // can't persist binary
      });
      var data = {
        family: state.family,
        counts: state.counts,
        slotSelections: state.slotSelections,
        preset: state.preset,
        step: state.step,
        maxVisited: state.maxVisited,
        vaultEnabled: state.vaultEnabled,
        vaultProductHandle: state.vaultProductHandle,
        vaultVariantId: state.vaultVariantId,
        customizerChoices: customizerChoices,
        savedAt: Date.now()
      };
      localStorage.setItem(STORAGE_KEY, JSON.stringify(data));
    } catch (e) { /* storage full or unavailable */ }
  }

  function loadStateFromStorage() {
    try {
      var raw = localStorage.getItem(STORAGE_KEY);
      if (!raw) return null;
      var data = JSON.parse(raw);
      // Expire after 24 hours
      if (Date.now() - data.savedAt > 86400000) {
        localStorage.removeItem(STORAGE_KEY);
        return null;
      }
      return data;
    } catch (e) { return null; }
  }

  function clearStateFromStorage() {
    try { localStorage.removeItem(STORAGE_KEY); } catch (e) { /* ignore */ }
  }

  function encodeBuildToParams(state) {
    var parts = [];
    if (state.preset) parts.push('preset=' + encodeURIComponent(state.preset));
    FACE_ORDER.forEach(function (face) {
      if (state.counts[face] > 0) {
        parts.push(face + '=' + state.counts[face]);
        var families = state.slotSelections[face] || [];
        if (families.length) {
          parts.push(face + 'c=' + families.map(function (f) { return encodeURIComponent(f); }).join(','));
        }
      }
    });
    if (state.family) parts.push('family=' + encodeURIComponent(state.family));
    // Encode D20 engraving choices (stock icons and custom text only)
    var engravings = (state.customizers || []).map(function (c) {
      if (!c || !c.isConfigured) return '';
      if (c.engravingChoice) return 'i:' + c.engravingChoice;
      if (c.customTextValue) return 't:' + c.customTextValue + (c.customFontValue ? '|' + c.customFontValue : '');
      return 'img'; // uploaded image — can't share
    });
    if (engravings.some(function (e) { return e; })) {
      parts.push('d20e=' + engravings.map(function (e) { return encodeURIComponent(e); }).join(','));
    }
    return parts.join('&');
  }

  function decodeBuildFromParams(search) {
    var params = new URLSearchParams(search);
    if (!params.has('d20') && !params.has('preset') && !params.has('d6')) return null;
    var build = { counts: {}, slotSelections: {}, preset: params.get('preset') || '', family: params.get('family') || '' };
    FACE_ORDER.forEach(function (face) {
      build.counts[face] = parseInt(params.get(face), 10) || 0;
      var colorways = params.get(face + 'c');
      build.slotSelections[face] = colorways ? colorways.split(',').map(decodeURIComponent) : [];
    });
    // Decode D20 engraving choices
    var d20eRaw = params.get('d20e');
    if (d20eRaw) {
      build.customizerChoices = d20eRaw.split(',').map(function (enc) {
        var val = decodeURIComponent(enc);
        if (!val) return null;
        if (val.indexOf('i:') === 0) return { type: 'stock', key: val.slice(2) };
        if (val.indexOf('t:') === 0) {
          var rest = val.slice(2);
          var pipeIdx = rest.lastIndexOf('|');
          if (pipeIdx > -1) return { type: 'text', text: rest.slice(0, pipeIdx), font: rest.slice(pipeIdx + 1) };
          return { type: 'text', text: rest, font: '' };
        }
        if (val === 'img') return { type: 'image' };
        return null;
      });
    }
    return build;
  }

  function DiceKitBuilder(root) {
    this.root = root;
    this.sectionId = root.getAttribute('data-section-id');
    this.config = JSON.parse(document.getElementById('DiceKitBuilderConfig-' + this.sectionId).textContent);
    this.catalog = {};
    this.vaultProducts = [];
    this.familyList = [];
    this.state = {
      family: '',
      counts: createEmptyCounts(),
      slotSelections: createEmptySlotSelections(),
      preset: '',
      busy: false,
      customizers: [],
      d20Metadata: {},
      vaultEnabled: false,
      vaultProductHandle: '',
      vaultVariantId: '',
      infoMessage: '',
      errorMessage: '',
      step: 1,
      maxVisited: 1
    };
    this.stepLabels = ['Choose', 'Build', 'Customize', 'Review'];
    this.handleHashChange = this.onHashChange.bind(this);
  }

  DiceKitBuilder.prototype.init = async function () {
    try {
      this.renderLoading();
      var responses = await Promise.all([
        this.fetchCollection(this.config.singlesCollectionHandle),
        this.fetchCollection(this.config.vaultsCollectionHandle)
      ]);
      this.catalog = this.parseSinglesCollection(responses[0]);
      this.vaultProducts = this.parseVaultCollection(responses[1]);
      this.familyList = Object.keys(this.catalog).sort(function (left, right) {
        return left.localeCompare(right);
      });

      if (!this.familyList.length) {
        throw new Error('No single-die products were found in the configured collection.');
      }

      this.state.family = this.familyList[0];

      if (this.vaultProducts.length) {
        this.state.vaultProductHandle = this.vaultProducts[0].handle;
        this.state.vaultVariantId = String(this.vaultProducts[0].variants[0].id);
      }

      // Restore from shared URL params first, then localStorage
      var sharedBuild = decodeBuildFromParams(window.location.search);
      var savedState = sharedBuild || loadStateFromStorage();
      if (savedState) {
        if (savedState.family && this.catalog[savedState.family]) {
          this.state.family = savedState.family;
        }
        if (savedState.preset) this.state.preset = savedState.preset;
        if (savedState.counts) {
          FACE_ORDER.forEach(function (face) {
            if (typeof savedState.counts[face] === 'number') {
              this.state.counts[face] = savedState.counts[face];
            }
          }, this);
        }
        if (savedState.slotSelections) {
          FACE_ORDER.forEach(function (face) {
            if (Array.isArray(savedState.slotSelections[face])) {
              this.state.slotSelections[face] = savedState.slotSelections[face].filter(function (f) {
                return this.catalog[f] && this.catalog[f].faces[face];
              }, this);
            }
          }, this);
        }
        this.syncSlotSelections(false);
        if (savedState.vaultEnabled) this.state.vaultEnabled = true;
        if (savedState.vaultProductHandle) this.state.vaultProductHandle = savedState.vaultProductHandle;
        if (savedState.vaultVariantId) this.state.vaultVariantId = savedState.vaultVariantId;
        if (savedState.maxVisited) this.state.maxVisited = Math.max(1, Math.min(4, savedState.maxVisited));
        if (sharedBuild) {
          this.state.step = 4;
          this.state.maxVisited = 4;
        }
      }

      this.renderShell();
      this.bindEvents();
      this.setupBeforeUnload();
      this.renderAll();
      var startStep = sharedBuild ? 4 : (this.getRequestedStepFromHash() || (savedState && savedState.step ? savedState.step : 1));
      this.goToStep(startStep, {
        force: true,
        allowFuture: true
      });

      // If we restored D20 selections, sync their customizers so step 3 works
      if (this.state.slotSelections.d20.length) {
        var pendingChoices = savedState && savedState.customizerChoices ? savedState.customizerChoices : null;
        this.syncD20Customizers().then(function () {
          if (pendingChoices) {
            this.reapplyCustomizerChoices(pendingChoices);
          }
        }.bind(this));
      }

      // Show toast after shell is rendered (needs DOM)
      if (sharedBuild) {
        this.showToast('🔗 A shared build was loaded — review it and make it your own!', 5000);
      }
    } catch (error) {
      this.root.innerHTML = '<div class="wizard__message wizard__message--error">' + escapeHtml(error.message || 'Unable to load the kit builder right now.') + '</div>';
    }
  };

  DiceKitBuilder.prototype.renderLoading = function () {
    this.root.innerHTML = '<div class="dice-kit-builder__loading">Loading available dice families…</div>';
  };

  DiceKitBuilder.prototype.fetchCollection = async function (handle) {
    return this.fetchAllCollectionProducts(handle);
  };

  DiceKitBuilder.prototype.parseSinglesCollection = function (products) {
    return this.buildCatalog(products);
  };

  DiceKitBuilder.prototype.parseVaultCollection = function (products) {
    return this.buildVaultCatalog(products);
  };

  DiceKitBuilder.prototype.fetchAllCollectionProducts = async function (handle) {
    if (!handle) {
      return [];
    }

    var page = 1;
    var products = [];

    while (true) {
      var response = await fetch('/collections/' + handle + '/products.json?limit=250&page=' + page, {
        headers: {
          'X-Requested-With': 'XMLHttpRequest',
          'Accept': 'application/json'
        }
      });

      if (!response.ok) {
        throw new Error('Unable to load collection data for ' + handle + '.');
      }

      var payload = await response.json();
      var batch = payload.products || [];
      products = products.concat(batch);

      if (batch.length < 250) {
        break;
      }

      page += 1;
    }

    return products;
  };

  DiceKitBuilder.prototype.buildCatalog = function (products) {
    var catalog = {};

    products.forEach(function (product) {
      this.extractDiceEntries(product).forEach(function (entry) {
        if (!catalog[entry.family]) {
          catalog[entry.family] = {
            family: entry.family,
            image: entry.image,
            faces: {}
          };
        }

        var current = catalog[entry.family].faces[entry.face];
        if (!current || this.shouldReplaceEntry(current, entry)) {
          catalog[entry.family].faces[entry.face] = entry;
        }

        if (!catalog[entry.family].image && entry.image) {
          catalog[entry.family].image = entry.image;
        }
      }, this);
    }, this);

    return catalog;
  };

  DiceKitBuilder.prototype.shouldReplaceEntry = function (current, candidate) {
    if (candidate.available && !current.available) {
      return true;
    }

    if (candidate.available === current.available) {
      return new Date(candidate.updatedAt).getTime() >= new Date(current.updatedAt).getTime();
    }

    return false;
  };

  DiceKitBuilder.prototype.extractDiceEntries = function (product) {
    var titleParts = (product.title || '').split(' - ');
    if (titleParts.length < 2) {
      return [];
    }

    var faceTitle = titleParts[titleParts.length - 1].trim().toUpperCase();
    var family = titleParts.slice(0, -1).join(' - ').trim();
    var image = product.images && product.images.length ? product.images[0].src : '';
    var updatedAt = product.updated_at || product.updatedAt || '';
    var entries = [];
    var primaryVariant = this.pickPreferredVariant(product.variants || []);
    var buildEntry = function (face, variant, customizable) {
      return {
        face: face,
        family: family,
        productHandle: product.handle,
        productTitle: product.title,
        variantId: String(variant.id),
        variantTitle: variant.title,
        available: Boolean(variant.available),
        inventoryQuantity: typeof variant.inventory_quantity === 'number' ? variant.inventory_quantity : null,
        priceCents: toCents(variant.price),
        image: (variant.featured_image && variant.featured_image.src) || image,
        updatedAt: updatedAt,
        customizable: Boolean(customizable)
      };
    };

    if (!primaryVariant) {
      return entries;
    }

    switch (faceTitle) {
      case 'D20':
        entries.push(buildEntry('d20', primaryVariant, true));
        break;
      case 'D12':
        entries.push(buildEntry('d12', primaryVariant, false));
        break;
      case 'D8':
        entries.push(buildEntry('d8', primaryVariant, false));
        break;
      case 'D6':
        entries.push(buildEntry('d6', primaryVariant, false));
        break;
      case 'D4':
        entries.push(buildEntry('d4', primaryVariant, false));
        break;
      case 'D10':
        (product.variants || []).forEach(function (variant) {
          var label = ((variant.option1 || '') + ' ' + (variant.title || '')).toUpperCase();
          if (label.indexOf('%') !== -1 || label.indexOf('00-90') !== -1) {
            entries.push(buildEntry('d00', variant, false));
          } else {
            entries.push(buildEntry('d10', variant, false));
          }
        });
        break;
      default:
        break;
    }

    return entries;
  };

  DiceKitBuilder.prototype.pickPreferredVariant = function (variants) {
    if (!variants || !variants.length) {
      return null;
    }

    for (var index = 0; index < variants.length; index += 1) {
      if (variants[index].available) {
        return variants[index];
      }
    }

    return variants[0];
  };

  DiceKitBuilder.prototype.buildVaultCatalog = function (products) {
    return products.map(function (product) {
      return {
        handle: product.handle,
        title: product.title,
        image: product.images && product.images.length ? product.images[0].src : '',
        variants: (product.variants || []).map(function (variant) {
          return {
            id: variant.id,
            title: variant.title,
            available: Boolean(variant.available),
            priceCents: toCents(variant.price)
          };
        }).filter(function (variant) {
          return variant.available;
        })
      };
    }).filter(function (product) {
      return product.variants.length;
    });
  };

  DiceKitBuilder.prototype.getStepCount = function () {
    return this.stepLabels.length;
  };

  DiceKitBuilder.prototype.getRequestedStepFromHash = function () {
    var match = window.location.hash.match(/step=(\d+)/);
    if (!match) {
      return null;
    }
    return parseInt(match[1], 10) || null;
  };

  DiceKitBuilder.prototype.onHashChange = function () {
    var requestedStep = this.getRequestedStepFromHash();
    if (!requestedStep) {
      return;
    }
    this.goToStep(requestedStep, {
      force: true,
      allowFuture: true,
      silentHash: true
    });
  };

  DiceKitBuilder.prototype.getSummaryData = function () {
    var selectedSlots = this.getSelectedSlots();
    var selectedLines = this.getSelectedLines();
    var subtotal = selectedSlots.reduce(function (total, slot) {
      return total + slot.priceCents;
    }, 0);
    var vaultProduct = this.getSelectedVaultProduct();
    var vaultVariant = null;
    var liveCheckCount = selectedSlots.filter(function (slot) {
      return !slot.entry.available;
    }).length;
    var pendingCustomizations = this.state.customizers.filter(function (customizer) {
      return customizer && !customizer.isConfigured;
    }).length;
    var awaitingD20Customizers = this.state.slotSelections.d20.length !== this.state.customizers.length;
    var preset = this.config.presets[this.state.preset] || null;

    if (vaultProduct) {
      for (var index = 0; index < vaultProduct.variants.length; index += 1) {
        if (String(vaultProduct.variants[index].id) === String(this.state.vaultVariantId)) {
          vaultVariant = vaultProduct.variants[index];
          break;
        }
      }
    }

    var vaultTotal = this.state.vaultEnabled && vaultVariant ? vaultVariant.priceCents : 0;
    var grandTotal = subtotal + vaultTotal;
    var soldOutCount = selectedSlots.filter(function (slot) {
      return slot.entry && !slot.entry.available;
    }).length;
    var addDisabled = this.state.busy || !selectedSlots.length || pendingCustomizations > 0 || awaitingD20Customizers || soldOutCount > 0;

    return {
      selectedSlots: selectedSlots,
      selectedLines: selectedLines,
      subtotal: subtotal,
      vaultProduct: vaultProduct,
      vaultVariant: vaultVariant,
      vaultTotal: vaultTotal,
      grandTotal: grandTotal,
      liveCheckCount: liveCheckCount,
      soldOutCount: soldOutCount,
      pendingCustomizations: pendingCustomizations,
      awaitingD20Customizers: awaitingD20Customizers,
      addDisabled: addDisabled,
      preset: preset,
      kitName: this.buildKitName()
    };
  };

  DiceKitBuilder.prototype.renderShell = function () {
    this.root.innerHTML = [
      '<div class="wizard__messages">',
      '  <div class="wizard__message wizard__message--error hidden" data-role="error"></div>',
      '  <div class="wizard__message wizard__message--info hidden" data-role="info"></div>',
      '</div>',
      '<div class="wizard__progress" data-role="progress" role="navigation" aria-label="Builder progress"></div>',
      '<div class="wizard__layout">',
      '  <div class="wizard__main">',
      '    <section class="wizard__step is-active" data-step="1" data-role="step-1" role="tabpanel" aria-label="Step 1: Choose a preset"></section>',
      '    <section class="wizard__step" data-step="2" data-role="step-2" role="tabpanel" aria-label="Step 2: Build your set"></section>',
      '    <section class="wizard__step" data-step="3" data-role="step-3" role="tabpanel" aria-label="Step 3: Customize D20s"></section>',
      '    <section class="wizard__step" data-step="4" data-role="step-4" role="tabpanel" aria-label="Step 4: Review and add to cart"></section>',
      '  </div>',
      '  <aside class="wizard__sidebar" data-role="sidebar" aria-label="Kit summary"></aside>',
      '</div>',
      '<div class="wizard__mobile-tray hidden" data-role="mobile-tray"></div>'
    ].join('');
  };

  DiceKitBuilder.prototype.bindEvents = function () {
    this.root.addEventListener('change', async function (event) {
      var target = event.target;

      if (target.matches('[data-family-select]')) {
        await this.onFamilyChanged(target.value);
        return;
      }

      if (target.matches('[data-face-input]')) {
        await this.setCount(target.getAttribute('data-face-input'), target.value);
        return;
      }

      if (target.matches('[data-slot-family]')) {
        await this.onSlotFamilyChanged(
          target.getAttribute('data-face'),
          target.getAttribute('data-slot-index'),
          target.value
        );
        return;
      }

      if (target.matches('[data-vault-toggle]')) {
        this.state.vaultEnabled = Boolean(target.checked);
        this.renderAll();
        return;
      }

      if (target.matches('[data-vault-product]')) {
        this.state.vaultProductHandle = target.value;
        this.syncVaultVariantSelection();
        this.renderAll();
        return;
      }

      if (target.matches('[data-vault-variant]')) {
        this.state.vaultVariantId = target.value;
        this.renderAll();
      }
    }.bind(this));

    this.root.addEventListener('click', async function (event) {
      var actionTarget = event.target.closest('[data-go-step], [data-next-step], [data-prev-step], [data-preset], [data-add-kit], [data-buy-now], [data-share-build], [data-face-decrement], [data-face-increment]');
      if (!actionTarget) {
        return;
      }

      if (actionTarget.hasAttribute('data-go-step')) {
        event.preventDefault();
        this.goToStep(actionTarget.getAttribute('data-go-step'), { force: true });
        return;
      }

      if (actionTarget.hasAttribute('data-next-step')) {
        event.preventDefault();
        await this.nextStep();
        return;
      }

      if (actionTarget.hasAttribute('data-prev-step')) {
        event.preventDefault();
        this.prevStep();
        return;
      }

      if (actionTarget.hasAttribute('data-preset')) {
        event.preventDefault();
        await this.applyPresetAndAdvance(actionTarget.getAttribute('data-preset'));
        return;
      }

      if (actionTarget.hasAttribute('data-face-decrement')) {
        event.preventDefault();
        await this.adjustCount(actionTarget.getAttribute('data-face-decrement'), -1);
        return;
      }

      if (actionTarget.hasAttribute('data-face-increment')) {
        event.preventDefault();
        await this.adjustCount(actionTarget.getAttribute('data-face-increment'), 1);
        return;
      }

      if (actionTarget.hasAttribute('data-add-kit')) {
        event.preventDefault();
        await this.addKitToCart();
      }

      if (actionTarget.hasAttribute('data-buy-now')) {
        event.preventDefault();
        await this.addKitToCart(true);
      }

      if (actionTarget.hasAttribute('data-share-build')) {
        event.preventDefault();
        this.copyShareUrl();
      }
    }.bind(this));

    window.addEventListener('hashchange', this.handleHashChange);
  };

  DiceKitBuilder.prototype.setupBeforeUnload = function () {
    var self = this;
    this._beforeUnloadHandler = function (event) {
      if (self.getSelectedSlots().length > 0 && !self.state.busy) {
        event.preventDefault();
        event.returnValue = '';
      }
    };
    window.addEventListener('beforeunload', this._beforeUnloadHandler);
  };

  DiceKitBuilder.prototype.getShareUrl = function () {
    var base = window.location.origin + window.location.pathname;
    var params = encodeBuildToParams(this.state);
    return base + '?' + params;
  };

  DiceKitBuilder.prototype.copyShareUrl = function () {
    var url = this.getShareUrl();
    var self = this;

    function showToast() {
      self.showToast('✅ Share link copied to clipboard!');
    }

    if (navigator.clipboard && navigator.clipboard.writeText) {
      navigator.clipboard.writeText(url).then(showToast);
    } else {
      var textarea = document.createElement('textarea');
      textarea.value = url;
      textarea.style.position = 'fixed';
      textarea.style.opacity = '0';
      document.body.appendChild(textarea);
      textarea.select();
      document.execCommand('copy');
      document.body.removeChild(textarea);
      showToast();
    }
  };

  DiceKitBuilder.prototype.showToast = function (message, duration) {
    duration = duration || 3500;
    var existing = this.root.querySelector('.wizard__toast');
    if (existing) existing.remove();

    var toast = document.createElement('div');
    toast.className = 'wizard__toast';
    toast.textContent = message;
    this.root.appendChild(toast);

    // Trigger reflow then animate in
    toast.offsetHeight; // eslint-disable-line no-unused-expressions
    toast.classList.add('is-visible');

    setTimeout(function () {
      toast.classList.remove('is-visible');
      setTimeout(function () { toast.remove(); }, 350);
    }, duration);
  };

  DiceKitBuilder.prototype.goToStep = function (step, options) {
    options = options || {};
    var targetStep = parseInt(step, 10);
    var maxStep = this.getStepCount();

    if (isNaN(targetStep)) {
      targetStep = 1;
    }

    targetStep = Math.max(1, Math.min(maxStep, targetStep));

    if (!this.state.slotSelections.d20.length && targetStep === 3) {
      targetStep = 4;
    }

    var maxVisited = options.allowFuture || options.force ? maxStep : this.state.maxVisited;
    if (targetStep > maxVisited) {
      targetStep = maxVisited;
    }

    this.state.step = targetStep;
    if (targetStep > this.state.maxVisited) {
      this.state.maxVisited = targetStep;
    }

    this.renderAll();

    // Scroll the wizard into view on step change
    if (this.root && this.root.scrollIntoView) {
      this.root.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }

    // Focus management for accessibility
    var stepEl = this.root.querySelector('[data-step="' + targetStep + '"]');
    if (stepEl) {
      var heading = stepEl.querySelector('h2, h3, [class*="heading"]');
      if (heading) {
        heading.setAttribute('tabindex', '-1');
        heading.focus({ preventScroll: true });
      }
    }

    if (!options.silentHash && window.location.hash !== '#step=' + targetStep) {
      window.location.hash = '#step=' + targetStep;
    }
  };

  DiceKitBuilder.prototype.nextStep = async function () {
    var summary = this.getSummaryData();

    if (this.state.step === 2) {
      if (!summary.selectedSlots.length) {
        this.state.errorMessage = 'Choose at least one die before continuing.';
        this.renderAll();
        return;
      }

      if (summary.soldOutCount > 0) {
        this.state.errorMessage = summary.soldOutCount + ' selected ' + (summary.soldOutCount === 1 ? 'die is' : 'dice are') + ' sold out. Please choose a different colorway for ' + (summary.soldOutCount === 1 ? 'that die' : 'those dice') + ' before continuing.';
        this.renderAll();
        return;
      }

      this.state.errorMessage = '';
      if (!this.state.slotSelections.d20.length) {
        this.goToStep(4, { force: true });
        return;
      }

      this.goToStep(3, { force: true });
      return;
    }

    if (this.state.step === 3) {
      if (summary.awaitingD20Customizers) {
        this.state.errorMessage = 'Please wait for the d20 customization options to finish loading.';
        this.renderAll();
        return;
      }

      if (summary.pendingCustomizations) {
        this.state.errorMessage = 'Finish customizing every d20 before continuing.';
        this.renderAll();
        return;
      }

      this.state.errorMessage = '';
      this.goToStep(4, { force: true });
      return;
    }

    this.goToStep(this.state.step + 1, { force: true });
  };

  DiceKitBuilder.prototype.prevStep = function () {
    if (this.state.step === 4 && !this.state.slotSelections.d20.length) {
      this.goToStep(2, { force: true });
      return;
    }
    this.goToStep(this.state.step - 1, { force: true });
  };

  DiceKitBuilder.prototype.renderAll = function () {
    var progress = this.root.querySelector('[data-role="progress"]');
    var step1 = this.root.querySelector('[data-role="step-1"]');
    var step2 = this.root.querySelector('[data-role="step-2"]');
    var step3 = this.root.querySelector('[data-role="step-3"]');
    var step4 = this.root.querySelector('[data-role="step-4"]');
    var sidebar = this.root.querySelector('[data-role="sidebar"]');
    var mobileTray = this.root.querySelector('[data-role="mobile-tray"]');

    this.renderMessages();

    if (progress) {
      progress.innerHTML = this.renderProgressBar();
    }

    if (step1) {
      step1.innerHTML = this.renderStep1();
      step1.classList.toggle('is-active', this.state.step === 1);
    }

    if (step2) {
      step2.innerHTML = this.renderStep2();
      step2.classList.toggle('is-active', this.state.step === 2);
    }

    if (step3) {
      step3.innerHTML = this.renderStep3();
      step3.classList.toggle('is-active', this.state.step === 3);
    }

    if (step4) {
      step4.innerHTML = this.renderStep4();
      step4.classList.toggle('is-active', this.state.step === 4);
    }

    if (sidebar) {
      sidebar.innerHTML = this.renderDesktopSidebar();
    }

    if (mobileTray) {
      mobileTray.innerHTML = this.renderMobileTray();
      mobileTray.classList.toggle('hidden', this.state.step === 1 || !this.getSelectedSlots().length);
    }

    this.state.customizers.forEach(function (customizer, index) {
      if (!customizer || !customizer.metadata) {
        return;
      }
      this.hydrateCustomizer(customizer, index, customizer.metadata);
    }, this);

    // Persist state to localStorage on every render
    saveStateToStorage(this.state);
  };

  DiceKitBuilder.prototype.renderMessages = function () {
    var error = this.root.querySelector('[data-role="error"]');
    var info = this.root.querySelector('[data-role="info"]');

    if (!error || !info) {
      return;
    }

    if (this.state.errorMessage) {
      error.textContent = this.state.errorMessage;
      error.classList.remove('hidden');
    } else {
      error.textContent = '';
      error.classList.add('hidden');
    }

    if (this.state.infoMessage) {
      info.textContent = this.state.infoMessage;
      info.classList.remove('hidden');
    } else {
      info.textContent = '';
      info.classList.add('hidden');
    }
  };

  DiceKitBuilder.prototype.renderProgressBar = function () {
    return this.stepLabels.map(function (label, index) {
      var stepNumber = index + 1;
      var classes = ['wizard__progress-step'];
      var disabled = '';
      var skipCustomize = !this.state.slotSelections.d20.length && stepNumber === 3;

      if (stepNumber === this.state.step) {
        classes.push('is-active');
      } else if (stepNumber <= this.state.maxVisited && !skipCustomize) {
        classes.push('is-visited');
      } else {
        disabled = ' disabled';
      }

      return [
        '<button type="button" class="' + classes.join(' ') + '" data-go-step="' + escapeHtml(stepNumber) + '"' + disabled + ' aria-label="Step ' + escapeHtml(stepNumber) + ': ' + escapeHtml(label) + '"' + (stepNumber === this.state.step ? ' aria-current="step"' : '') + '>',
        '  <span class="wizard__progress-dot" aria-hidden="true">' + escapeHtml(stepNumber) + '</span>',
        '  <span class="wizard__progress-label">' + escapeHtml(label) + '</span>',
        '</button>'
      ].join('');
    }, this).join('');
  };

  DiceKitBuilder.prototype.renderStep1 = function () {
    var presets = this.config.presets || {};
    var cards = Object.keys(presets).map(function (key) {
      var preset = presets[key];
      var dieCount = FACE_ORDER.reduce(function (total, face) {
        return total + (preset.counts[face] || 0);
      }, 0);
      var activeClass = this.state.preset === key ? ' is-active' : '';

      return [
        '<button type="button" class="wizard__preset-card' + activeClass + '" data-preset="' + escapeHtml(key) + '">',
        '  <span class="wizard__preset-card-label">' + escapeHtml(preset.label) + '</span>',
        '  <span class="wizard__preset-card-desc">' + escapeHtml(preset.description) + '</span>',
        '  <span class="wizard__preset-card-dice">' + escapeHtml(dieCount) + ' ' + (dieCount === 1 ? 'die' : 'dice') + '</span>',
        '</button>'
      ].join('');
    }, this);

    cards.push([
      '<button type="button" class="wizard__preset-card wizard__preset-card--custom' + (!this.state.preset ? ' is-active' : '') + '" data-preset="custom">',
      '  <span class="wizard__preset-card-label">Custom</span>',
      '  <span class="wizard__preset-card-desc">Start from scratch and choose the exact dice and colorways you want.</span>',
      '  <span class="wizard__preset-card-dice">Mix any available singles into your own kit.</span>',
      '</button>'
    ].join(''));

    return [
      '<div class="wizard__step-content">',
      '  <h2 class="wizard__step-title">What are you building?</h2>',
      '  <p class="wizard__step-subtitle">Pick a starting point, then customize every die.</p>',
      '  <div class="wizard__preset-grid">' + cards.join('') + '</div>',
      '</div>'
    ].join('');
  };

  DiceKitBuilder.prototype.renderStep2 = function () {
    var familyEntry = this.catalog[this.state.family];
    var offeredFaces = [];
    var liveCheckFaces = [];

    if (familyEntry) {
      offeredFaces = FACE_ORDER.filter(function (face) {
        return Boolean(familyEntry.faces[face]);
      }).map(function (face) {
        return FACE_LABELS[face];
      });

      liveCheckFaces = FACE_ORDER.filter(function (face) {
        return familyEntry.faces[face] && !familyEntry.faces[face].available;
      }).map(function (face) {
        return FACE_LABELS[face];
      });
    }

    var cards = FACE_ORDER.map(function (face) {
      var selectableFamilies = this.getSelectableFamiliesForFace(face);
      var defaultFamily = this.getDefaultFamilyForFace(face);
      var entry = defaultFamily && this.catalog[defaultFamily] ? this.catalog[defaultFamily].faces[face] : null;
      var exists = Boolean(entry);
      var selections = this.state.slotSelections[face] || [];
      var classes = ['wizard__die-card'];
      var availabilityText = 'Not currently offered in the singles catalog.';

      if (selections.length) {
        classes.push('is-selected');
      }
      if (!exists) {
        classes.push('is-unavailable');
      } else if (!entry.available) {
        classes.push('is-live-check');
      }

      if (selectableFamilies.length) {
        availabilityText = 'Choose the count now, then pick the exact colorway for each die below.';
        if (entry && !entry.available) {
          availabilityText = 'Some colorways for this face are flagged unavailable online. The builder will verify them live when you add the kit.';
        }
      }

      return [
        '<div class="' + classes.join(' ') + '" data-die-face="' + escapeHtml(face) + '">',
        '  <div class="wizard__die-card-header">',
        '    <div>',
        '      <h3 class="wizard__die-card-face">' + escapeHtml(FACE_LABELS[face]) + '</h3>',
        '      <p class="wizard__die-card-desc">' + escapeHtml(FACE_DESCRIPTIONS[face]) + '</p>',
        '    </div>',
        '    <span class="wizard__die-card-price">' + escapeHtml(entry ? 'From ' + formatMoney(entry.priceCents) : 'Not offered') + '</span>',
        '  </div>',
        '  <p class="wizard__small-note">' + escapeHtml(availabilityText) + '</p>',
        '  <div class="wizard__die-card-stepper" role="group" aria-label="' + escapeHtml(face) + ' quantity">',
        '    <button type="button" class="button button--secondary" data-face-decrement="' + escapeHtml(face) + '"' + (exists ? '' : ' disabled') + ' aria-label="Decrease ' + escapeHtml(face) + ' count">−</button>',
        '    <input type="number" min="0" max="12" inputmode="numeric" data-face-input="' + escapeHtml(face) + '" value="' + escapeHtml(this.state.counts[face]) + '"' + (exists ? '' : ' disabled') + ' aria-label="' + escapeHtml(face) + ' count">',
        '    <button type="button" class="button button--secondary" data-face-increment="' + escapeHtml(face) + '"' + (exists ? '' : ' disabled') + ' aria-label="Increase ' + escapeHtml(face) + ' count">+</button>',
        '  </div>',
             selections.length ? '  <div class="wizard__die-card-slots">' + selections.map(function (family, slotIndex) {
               var slotEntry = this.catalog[family] && this.catalog[family].faces[face];
               var slotSoldOut = slotEntry && !slotEntry.available;
               var inputId = 'DiceKitSlot-' + escapeHtml(this.sectionId) + '-' + escapeHtml(face) + '-' + escapeHtml(slotIndex);
               var self = this;
               return [
                 '<div class="wizard__die-slot' + (slotSoldOut ? ' is-sold-out' : '') + '">',
                 '  <img class="wizard__die-slot-thumb" src="' + escapeHtml(this.getSlotPreview(face, slotIndex, slotEntry)) + '" alt="' + escapeHtml(family + ' ' + FACE_LABELS[face]) + '">',
                 '  <div class="wizard__die-slot-info">',
                 '    <label class="wizard__die-slot-label" for="' + inputId + '">' + escapeHtml(FACE_LABELS[face]) + ' #' + escapeHtml(slotIndex + 1) + '</label>',
                 slotSoldOut ? '    <span class="wizard__die-slot-sold-out-badge">Sold out — pick another</span>' : '',
                 '    <select class="wizard__select" id="' + inputId + '" data-slot-family data-face="' + escapeHtml(face) + '" data-slot-index="' + escapeHtml(slotIndex) + '">',
                          selectableFamilies.map(function (optionFamily) {
                            var optEntry = self.catalog[optionFamily] && self.catalog[optionFamily].faces[face];
                            var label = optionFamily;
                            var disabled = false;
                            if (optEntry) {
                              if (!optEntry.available) {
                                label += ' (Sold out)';
                                disabled = true;
                              }
                            }
                            return '<option value="' + escapeHtml(optionFamily) + '"' + (optionFamily === family ? ' selected' : '') + (disabled ? ' disabled' : '') + '>' + escapeHtml(label) + '</option>';
                          }).join(''),
                 '    </select>',
                 '  </div>',
                 '</div>'
               ].join('');
             }, this).join('') + '</div>' : '',
        '</div>'
      ].join('');
    }, this).join('');

    return [
      '<div class="wizard__step-content">',
      '  <h2 class="wizard__step-title">Build your set</h2>',
      '  <p class="wizard__step-subtitle">Start with one colorway, then customize each die in your kit.</p>',
      '  <div class="wizard__starting-colorway">',
      '    <label class="wizard__starting-colorway-label" for="DiceKitFamily-' + escapeHtml(this.sectionId) + '">Starting colorway</label>',
      '    <div>',
      '      <select class="wizard__select" id="DiceKitFamily-' + escapeHtml(this.sectionId) + '" data-family-select>' + this.familyList.map(function (family) {
               return '<option value="' + escapeHtml(family) + '"' + (family === this.state.family ? ' selected' : '') + '>' + escapeHtml(family) + '</option>';
             }, this).join('') + '</select>',
      familyEntry ? '      <p class="wizard__small-note">Starting with ' + escapeHtml(this.state.family) + (offeredFaces.length ? ' for ' + escapeHtml(offeredFaces.join(', ')) : '') + '.</p>' : '',
      liveCheckFaces.length ? '      <p class="wizard__small-note" style="color: rgb(var(--color-base-accent-2));">Sold out in this colorway: ' + escapeHtml(liveCheckFaces.join(', ')) + '. Pick a different colorway for those dice below.</p>' : '',
      '    </div>',
      '  </div>',
      this.renderVisualTray(),
      '  <div class="wizard__die-cards">' + cards + '</div>',
      '  <div class="wizard__nav">',
      '    <button type="button" class="button button--secondary wizard__nav-back" data-prev-step>← Back to presets</button>',
      '    <button type="button" class="button button--primary wizard__nav-next" data-next-step' + (this.getSelectedSlots().length && !this.getSummaryData().soldOutCount ? '' : ' disabled') + '>Continue →</button>',
      '  </div>',
      '</div>'
    ].join('');
  };

  DiceKitBuilder.prototype.renderVisualTray = function () {
    var summary = this.getSummaryData();

    if (!summary.selectedSlots.length) {
      return [
        '<div class="wizard__visual-tray">',
        '  <div class="wizard__visual-tray-placeholder">Your dice will appear here as you build.</div>',
        '</div>'
      ].join('');
    }

    return [
      '<div class="wizard__visual-tray">',
      '  <div class="wizard__visual-tray-dice">',
            summary.selectedSlots.map(function (slot) {
              var soldOut = slot.entry && !slot.entry.available;
              return [
                '<div class="wizard__visual-tray-die' + (soldOut ? ' is-sold-out' : '') + '">',
                '  <img src="' + escapeHtml(slot.previewImage) + '" alt="' + escapeHtml(slot.family + ' ' + FACE_LABELS[slot.face]) + '">',
                '  <span>' + escapeHtml(FACE_LABELS[slot.face]) + '</span>',
                '</div>'
              ].join('');
            }).join(''),
      '  </div>',
      '  <div class="wizard__visual-tray-summary">',
      '    <span>' + escapeHtml(summary.selectedSlots.length) + ' dice</span>',
      '    <span>' + escapeHtml(formatMoney(summary.subtotal)) + '</span>',
      '  </div>',
      '</div>'
    ].join('');
  };

  DiceKitBuilder.prototype.renderStep3 = function () {
    var summary = this.getSummaryData();

    return [
      '<div class="wizard__step-content">',
      '  <h2 class="wizard__step-title">Customize your D20s</h2>',
      '  <p class="wizard__step-subtitle">Every d20 in your kit keeps the Shiny Math Rocks custom crit process.</p>',
      summary.awaitingD20Customizers && this.state.slotSelections.d20.length ? '<p class="wizard__small-note">Loading your d20 customization options…</p>' : '',
      summary.pendingCustomizations ? '<p class="wizard__small-note">Finish customizing ' + escapeHtml(summary.pendingCustomizations) + ' d20' + (summary.pendingCustomizations === 1 ? '' : 's') + ' before continuing.</p>' : '',
      this.state.slotSelections.d20.length ? '<div class="wizard__customizer-list" data-role="customizers">' + this.state.customizers.map(function (customizer, index) {
        return this.renderCustomizerMarkup(customizer, index, customizer.metadata || this.state.d20Metadata[customizer.family] || {});
      }, this).join('') + '</div>' : '<p class="wizard__small-note" data-role="customizers">This build does not include any d20s, so there is nothing to customize.</p>',
      '  <div class="wizard__nav">',
      '    <button type="button" class="button button--secondary wizard__nav-back" data-prev-step>← Back</button>',
      '    <button type="button" class="button button--primary wizard__nav-next" data-next-step' + ((summary.awaitingD20Customizers || summary.pendingCustomizations) ? ' disabled' : '') + '>Continue to review →</button>',
      '  </div>',
      '</div>'
    ].join('');
  };

  DiceKitBuilder.prototype.renderStep4 = function () {
    var summary = this.getSummaryData();
    var vaultFieldMarkup = '';

    if (!this.vaultProducts.length) {
      vaultFieldMarkup = '<p class="wizard__small-note">No vaults are currently available in the configured collection.</p>';
    } else {
      vaultFieldMarkup = [
        '<div class="wizard__review-vault-fields' + (this.state.vaultEnabled ? '' : ' hidden') + '">',
        '  <label class="wizard__small-note" for="DiceKitVaultProduct-' + escapeHtml(this.sectionId) + '">Vault style</label>',
        '  <select class="wizard__select" id="DiceKitVaultProduct-' + escapeHtml(this.sectionId) + '" data-vault-product>' + this.vaultProducts.map(function (product) {
               return '<option value="' + escapeHtml(product.handle) + '"' + (product.handle === this.state.vaultProductHandle ? ' selected' : '') + '>' + escapeHtml(product.title) + '</option>';
             }, this).join('') + '</select>',
        '  <label class="wizard__small-note" for="DiceKitVaultVariant-' + escapeHtml(this.sectionId) + '">Vault option</label>',
        '  <select class="wizard__select" id="DiceKitVaultVariant-' + escapeHtml(this.sectionId) + '" data-vault-variant>' + (summary.vaultProduct ? summary.vaultProduct.variants.map(function (variant) {
               return '<option value="' + escapeHtml(variant.id) + '"' + (String(variant.id) === String(this.state.vaultVariantId) ? ' selected' : '') + '>' + escapeHtml(variant.title) + ' — ' + escapeHtml(formatMoney(variant.priceCents)) + '</option>';
             }, this).join('') : '') + '</select>',
        '</div>'
      ].join('');
    }

    return [
      '<div class="wizard__step-content">',
      '<h2 class="wizard__step-title">Review &amp; add to cart</h2>',
      '<p class="wizard__step-subtitle">See the full kit, optional vault upsell, and final total before sending everything to your cart.</p>',
      '<p class="wizard__small-note">' + escapeHtml(summary.kitName) + '</p>',
      summary.preset ? '<p class="wizard__small-note">Preset: ' + escapeHtml(summary.preset.label) + '</p>' : '<p class="wizard__small-note">Preset: Custom</p>',
      summary.selectedSlots.length ? '<div class="wizard__review-gallery">' + summary.selectedSlots.map(function (slot) {
        return [
          '<div class="wizard__review-die' + (slot.entry.available ? '' : ' is-live-check') + '">',
          '  <img src="' + escapeHtml(slot.previewImage) + '" alt="' + escapeHtml(slot.family + ' ' + FACE_LABELS[slot.face]) + '">',
          '  <span class="wizard__review-die-face">' + escapeHtml(slot.slotLabel) + '</span>',
          '  <span class="wizard__review-die-family">' + escapeHtml(slot.family) + '</span>',
          '</div>'
        ].join('');
      }).join('') + '</div>' : '<p class="wizard__small-note">Choose at least one die to start building.</p>',
      summary.selectedLines.length ? '<ul class="wizard__review-lines">' + summary.selectedLines.map(function (line) {
        return '<li><span>' + escapeHtml(line.label) + ' × ' + escapeHtml(line.quantity) + '</span><span>' + escapeHtml(formatMoney(line.priceCents * line.quantity)) + '</span></li>';
      }).join('') + '</ul>' : '',
      '<div class="wizard__review-vault">',
      '  <label class="wizard__review-vault-label">',
      '    <input type="checkbox" data-vault-toggle' + (this.state.vaultEnabled ? ' checked' : '') + '>',
      '    <span>Add a dice vault to this order.</span>',
      '  </label>',
      vaultFieldMarkup,
      summary.vaultProduct && summary.vaultVariant && this.state.vaultEnabled ? '<p class="wizard__small-note">Vault: ' + escapeHtml(summary.vaultProduct.title) + ' / ' + escapeHtml(summary.vaultVariant.title) + ' — ' + escapeHtml(formatMoney(summary.vaultVariant.priceCents)) + '</p>' : '',
      '</div>',
      summary.liveCheckCount > 0 ? '<p class="wizard__small-note">Some selected dice are currently flagged unavailable online. We verify those live during add-to-cart instead of blocking them here.</p>' : '',
      summary.awaitingD20Customizers ? '<p class="wizard__small-note">Loading your d20 customization options…</p>' : '',
      summary.pendingCustomizations > 0 ? '<p class="wizard__small-note">Finish customizing ' + escapeHtml(summary.pendingCustomizations) + ' d20' + (summary.pendingCustomizations === 1 ? '' : 's') + ' before adding your kit.</p>' : '',
      '<div class="wizard__review-total"><span>Grand total</span><span>' + escapeHtml(formatMoney(summary.grandTotal)) + '</span></div>',
      '<div class="wizard__review-actions">',
      '  <button type="button" class="button button--secondary" data-add-kit' + (summary.addDisabled ? ' disabled' : '') + '>' + (this.state.busy ? 'Adding…' : 'Add to cart') + '</button>',
      '  <button type="button" class="button button--primary" data-buy-now' + (summary.addDisabled ? ' disabled' : '') + '>' + (this.state.busy ? 'Processing…' : 'Buy now →') + '</button>',
      '</div>',
      '<div class="wizard__trust-signals">',
      '  <span>🔒 Secure checkout</span>',
      '  <span>📦 Free shipping on orders over $75</span>',
      '  <span>↩️ 30-day return policy</span>',
      '</div>',
      '<div class="wizard__share-build">',
      '  <button type="button" class="wizard__share-btn" data-share-build>🔗 Share this build</button>',
      '</div>',
      '<p class="wizard__fine-print">Builder pricing uses the published single-die prices for each selected die. Availability is checked live when the BOM lines are added to cart.</p>',
      this.renderJsonLd(),
      '<div class="wizard__nav">',
      '  <button type="button" class="button button--secondary wizard__nav-back" data-prev-step>← Back</button>',
      '</div>',
      '</div>'
    ].join('');
  };

  DiceKitBuilder.prototype.renderMobileTray = function () {
    var summary = this.getSummaryData();

    if (!summary.selectedSlots.length) {
      return '';
    }

    return [
      '<div class="wizard__mobile-tray-dice">',
          summary.selectedSlots.map(function (slot) {
            return '<img src="' + escapeHtml(slot.previewImage) + '" alt="' + escapeHtml(slot.slotLabel) + '">';
          }).join(''),
      '</div>',
      '<div class="wizard__mobile-tray-info">',
      '  <span class="wizard__mobile-tray-count">' + escapeHtml(summary.selectedSlots.length) + ' dice</span>',
      '  <span class="wizard__mobile-tray-total">' + escapeHtml(formatMoney(summary.grandTotal)) + '</span>',
      '</div>',
      '<button type="button" class="wizard__mobile-tray-action" data-go-step="4">Review</button>'
    ].join('');
  };

  DiceKitBuilder.prototype.renderJsonLd = function () {
    var summary = this.getSummaryData();
    var json;

    if (!summary.selectedSlots.length) {
      return '';
    }

    json = {
      '@context': 'https://schema.org',
      '@type': 'Product',
      name: summary.kitName,
      description: summary.preset ? summary.preset.description : 'Custom dice kit',
      offers: {
        '@type': 'Offer',
        priceCurrency: 'USD',
        price: (summary.grandTotal / 100).toFixed(2),
        availability: 'InStock'
      },
      isRelatedTo: summary.selectedSlots.map(function (slot) {
        return {
          '@type': 'Product',
          name: slot.entry.productTitle || (slot.family + ' ' + FACE_LABELS[slot.face]),
          offers: {
            '@type': 'Offer',
            priceCurrency: 'USD',
            price: (slot.priceCents / 100).toFixed(2),
            availability: 'InStock'
          }
        };
      })
    };

    return '<script type="application/ld+json">' + JSON.stringify(json).replace(/<\//g, '<\\/') + '</script>';
  };

  DiceKitBuilder.prototype.renderDesktopSidebar = function () {
    var summary = this.getSummaryData();
    var currentLabel = this.stepLabels[this.state.step - 1];

    return [
      '<h2 class="wizard__sidebar-title">' + escapeHtml(summary.kitName) + '</h2>',
      '<p class="wizard__sidebar-step">Step ' + escapeHtml(this.state.step) + ' of ' + escapeHtml(this.getStepCount()) + ' — ' + escapeHtml(currentLabel) + '</p>',
      summary.selectedSlots.length ? '<div class="wizard__sidebar-gallery">' + summary.selectedSlots.map(function (slot) {
        return [
          '<div class="wizard__sidebar-die">',
          '  <img src="' + escapeHtml(slot.previewImage) + '" alt="' + escapeHtml(slot.slotLabel) + '">',
          '  <span>' + escapeHtml(FACE_LABELS[slot.face]) + '</span>',
          '</div>'
        ].join('');
      }).join('') + '</div>' : '<div class="wizard__sidebar-empty">Choose at least one die to start building.</div>',
      summary.selectedLines.length ? '<ul class="wizard__sidebar-lines">' + summary.selectedLines.map(function (line) {
        return '<li><span>' + escapeHtml(line.label) + ' × ' + escapeHtml(line.quantity) + '</span><span>' + escapeHtml(formatMoney(line.priceCents * line.quantity)) + '</span></li>';
      }).join('') + '</ul>' : '',
      '<div class="wizard__sidebar-total"><span>Total</span><span>' + escapeHtml(formatMoney(summary.grandTotal)) + '</span></div>',
      '<div class="wizard__review-actions">',
      this.state.step === 4
        ? '  <button type="button" class="button button--secondary" data-add-kit' + (summary.addDisabled ? ' disabled' : '') + '>' + (this.state.busy ? 'Adding…' : 'Add to cart') + '</button>' +
          '  <button type="button" class="button button--primary" data-buy-now' + (summary.addDisabled ? ' disabled' : '') + '>' + (this.state.busy ? 'Processing…' : 'Buy now →') + '</button>'
        : '  <button type="button" class="button button--primary" disabled>Review to add</button>',
      '</div>'
    ].join('');
  };

  DiceKitBuilder.prototype.getDefaultFamilyForFace = function (face) {
    if (this.catalog[this.state.family] && this.catalog[this.state.family].faces[face]) {
      return this.state.family;
    }

    return this.familyList.find(function (family) {
      return this.catalog[family] && this.catalog[family].faces[face];
    }, this) || '';
  };

  DiceKitBuilder.prototype.getSelectableFamiliesForFace = function (face) {
    return this.familyList.filter(function (family) {
      return this.catalog[family] && this.catalog[family].faces[face];
    }, this);
  };

  DiceKitBuilder.prototype.syncSlotSelections = function (resetAll) {
    FACE_ORDER.forEach(function (face) {
      var nextSelections = [];
      var currentSelections = this.state.slotSelections[face] || [];
      var targetCount = this.state.counts[face];
      var defaultFamily = this.getDefaultFamilyForFace(face);

      for (var index = 0; index < targetCount; index += 1) {
        var selectedFamily = resetAll ? defaultFamily : currentSelections[index];

        if (!selectedFamily || !this.catalog[selectedFamily] || !this.catalog[selectedFamily].faces[face]) {
          selectedFamily = defaultFamily;
        }

        nextSelections.push(selectedFamily);
      }

      this.state.slotSelections[face] = nextSelections;
    }, this);
  };

  DiceKitBuilder.prototype.getSlotPreview = function (face, slotIndex, entry) {
    if (face === 'd20' && this.state.customizers[slotIndex] && this.state.customizers[slotIndex].previewUrl) {
      return this.state.customizers[slotIndex].previewUrl;
    }

    return entry.image;
  };

  DiceKitBuilder.prototype.getSelectedSlots = function () {
    return FACE_ORDER.reduce(function (slots, face) {
      (this.state.slotSelections[face] || []).forEach(function (family, slotIndex) {
        var entry = this.catalog[family] && this.catalog[family].faces[face];
        if (!entry) {
          return;
        }

        slots.push({
          face: face,
          family: family,
          slotIndex: slotIndex,
          slotLabel: FACE_LABELS[face] + ' #' + (slotIndex + 1),
          priceCents: entry.priceCents,
          entry: entry,
          previewImage: this.getSlotPreview(face, slotIndex, entry)
        });
      }, this);

      return slots;
    }.bind(this), []);
  };

  DiceKitBuilder.prototype.buildSummaryLines = function (selectedSlots) {
    var grouped = {};
    var lines = [];

    selectedSlots.forEach(function (slot) {
      var key = slot.face + '::' + slot.family;
      if (!grouped[key]) {
        grouped[key] = {
          face: slot.face,
          family: slot.family,
          label: FACE_LABELS[slot.face] + ' — ' + slot.family,
          quantity: 0,
          priceCents: slot.priceCents
        };
        lines.push(grouped[key]);
      }

      grouped[key].quantity += 1;
    });

    return lines;
  };

  DiceKitBuilder.prototype.getSelectedLines = function () {
    return this.buildSummaryLines(this.getSelectedSlots());
  };

  DiceKitBuilder.prototype.buildKitName = function () {
    var families = this.getSelectedSlots().reduce(function (list, slot) {
      if (list.indexOf(slot.family) === -1) {
        list.push(slot.family);
      }
      return list;
    }, []);
    if (!families.length) {
      return 'Custom Kit';
    }
    var leadFamily = families.length === 1 ? families[0] : 'Mixed Colorway';
    var preset = this.config.presets[this.state.preset];
    if (preset) {
      return leadFamily + ' — ' + preset.label;
    }

    return leadFamily + ' — Custom Kit';
  };

  DiceKitBuilder.prototype.onFamilyChanged = async function (family) {
    if (!this.catalog[family] || family === this.state.family) {
      return;
    }

    var hadSelections = this.getSelectedSlots().length > 0;
    this.state.family = family;
    this.state.errorMessage = '';
    this.syncSlotSelections(true);
    this.clearCustomizers();
    this.state.infoMessage = hadSelections ? 'Updated the selected dice to start from ' + family + '. Reconfirm any d20 engravings after mixing colorways again.' : '';
    this.renderAll();
    await this.syncD20Customizers();
  };

  DiceKitBuilder.prototype.applyPreset = async function (presetKey) {
    var preset = this.config.presets[presetKey];
    if (!preset) {
      return;
    }

    var counts = createEmptyCounts();
    var fallbackFaces = [];

    FACE_ORDER.forEach(function (face) {
      var requested = preset.counts[face] || 0;
      if (!requested) {
        return;
      }

      counts[face] = requested;
      if (!this.catalog[this.state.family] || !this.catalog[this.state.family].faces[face]) {
        fallbackFaces.push(FACE_LABELS[face]);
      }
    }, this);

    this.state.preset = presetKey;
    this.state.counts = counts;
    this.syncSlotSelections(true);
    this.state.infoMessage = fallbackFaces.length ? 'The ' + preset.label + ' preset starts with ' + this.state.family + ' where possible, then falls back to another matching colorway for ' + fallbackFaces.join(', ') + '.' : '';
    this.state.errorMessage = '';
    this.clearCustomizers();
    this.renderAll();
    await this.syncD20Customizers();
  };

  DiceKitBuilder.prototype.applyPresetAndAdvance = async function (presetKey) {
    if (presetKey === 'custom') {
      await this.clearPreset();
    } else {
      await this.applyPreset(presetKey);
    }
    this.goToStep(2, { force: true });
  };

  DiceKitBuilder.prototype.clearPreset = async function () {
    this.state.preset = '';
    this.state.counts = createEmptyCounts();
    this.state.slotSelections = createEmptySlotSelections();
    this.state.infoMessage = '';
    this.state.errorMessage = '';
    this.clearCustomizers();
    this.renderAll();
    await this.syncD20Customizers();
  };

  DiceKitBuilder.prototype.adjustCount = async function (face, delta) {
    await this.setCount(face, (this.state.counts[face] || 0) + delta);
  };

  DiceKitBuilder.prototype.setCount = async function (face, value) {
    if (!this.getSelectableFamiliesForFace(face).length) {
      return;
    }

    var numericValue = parseInt(value, 10);
    if (isNaN(numericValue)) {
      numericValue = 0;
    }

    numericValue = Math.max(0, Math.min(12, numericValue));
    this.state.counts[face] = numericValue;
    this.syncSlotSelections(false);

    if (this.state.preset) {
      this.state.preset = '';
    }

    this.state.infoMessage = '';
    this.state.errorMessage = '';
    this.renderAll();

    if (face === 'd20') {
      await this.syncD20Customizers();
    }
  };

  DiceKitBuilder.prototype.resetCustomizerAt = function (index) {
    var customizer = this.state.customizers[index];
    if (customizer) {
      delete window.savedDiceFiles[customizer.diceFilesKey];
    }
    this.state.customizers[index] = null;
  };

  DiceKitBuilder.prototype.onSlotFamilyChanged = async function (face, slotIndex, family) {
    var numericIndex = parseInt(slotIndex, 10);
    if (isNaN(numericIndex) || !this.catalog[family] || !this.catalog[family].faces[face]) {
      return;
    }

    if (this.state.slotSelections[face][numericIndex] === family) {
      return;
    }

    this.state.slotSelections[face][numericIndex] = family;
    this.state.errorMessage = '';
    this.state.infoMessage = '';

    if (face === 'd20') {
      this.resetCustomizerAt(numericIndex);
      this.state.infoMessage = 'Updated D20 #' + (numericIndex + 1) + ' to ' + family + '. Reconfirm its custom crit preview below.';
      await this.syncD20Customizers();
      return;
    }

    this.renderAll();
  };

  DiceKitBuilder.prototype.clearCustomizers = function () {
    this.state.customizers.forEach(function (customizer) {
      if (customizer) {
        delete window.savedDiceFiles[customizer.diceFilesKey];
      }
    });
    this.state.customizers = [];
    var container = this.root.querySelector('[data-role="customizers"]');
    if (container) {
      container.innerHTML = '';
    }
  };

  DiceKitBuilder.prototype.syncD20Customizers = async function () {
    var desiredFamilies = this.state.slotSelections.d20 || [];

    if (!desiredFamilies.length) {
      this.clearCustomizers();
      if (this.state.step === 3) {
        this.state.step = 4;
      }
      this.renderAll();
      return;
    }

    var metadataByIndex;
    try {
      metadataByIndex = await Promise.all(desiredFamilies.map(function (family) {
        return this.loadD20Metadata(this.catalog[family].faces.d20);
      }, this));
    } catch (error) {
      this.state.errorMessage = error.message || 'Unable to load d20 customization options right now.';
      this.clearCustomizers();
      this.renderAll();
      return;
    }

    this.state.errorMessage = '';

    var previousCustomizers = this.state.customizers.slice();
    var nextCustomizers = [];

    desiredFamilies.forEach(function (family, index) {
      var metadata = metadataByIndex[index];
      var existing = previousCustomizers[index];

      if (!existing || existing.family !== family) {
        if (existing) {
          delete window.savedDiceFiles[existing.diceFilesKey];
        }
        existing = this.createCustomizerState(index, metadata, family);
      }

      existing.family = family;
      existing.metadata = metadata;
      nextCustomizers.push(existing);
    }, this);

    previousCustomizers.slice(desiredFamilies.length).forEach(function (customizer) {
      if (customizer) {
        delete window.savedDiceFiles[customizer.diceFilesKey];
      }
    });

    this.state.customizers = nextCustomizers;
    this.renderAll();
  };

  DiceKitBuilder.prototype.reapplyCustomizerChoices = function (choices) {
    if (!choices || !choices.length) return;
    var imageChoicesExist = false;

    choices.forEach(function (choice, index) {
      var customizer = this.state.customizers[index];
      if (!choice || !customizer) return;

      if (choice.type === 'stock' && choice.key && this.config.markups[choice.key]) {
        customizer.engravingChoice = choice.key;
        stockElementClick(customizer, choice.key);
      } else if (choice.type === 'text' && choice.text) {
        customizer.customTextValue = choice.text;
        customizer.customFontValue = choice.font || '';
        // Set the input values, then trigger render
        if (customizer.customTextMsg) {
          customizer.customTextMsg.value = choice.text;
        }
        if (customizer.customFont && choice.font) {
          for (var i = 0; i < customizer.customFont.options.length; i++) {
            if (customizer.customFont.options[i].text === choice.font) {
              customizer.customFont.selectedIndex = i;
              break;
            }
          }
        }
        renderAndStoreCustomText(customizer);
      } else if (choice.type === 'image') {
        imageChoicesExist = true;
        // Can't restore uploaded images — user must re-upload
      }
    }, this);

    if (imageChoicesExist) {
      this.showToast('⚠️ Custom uploaded images couldn\'t be restored — please re-upload them on step 3.', 5000);
    }
  };

  DiceKitBuilder.prototype.loadD20Metadata = async function (entry) {
    if (this.state.d20Metadata[entry.productHandle]) {
      return this.state.d20Metadata[entry.productHandle];
    }

    var response = await fetch('/products/' + entry.productHandle, {
      headers: {
        'X-Requested-With': 'XMLHttpRequest'
      }
    });

    if (!response.ok) {
      throw new Error('Unable to load d20 customization data for ' + entry.productTitle + '.');
    }

    var html = await response.text();
    var blankMatch = html.match(/product\s*:\s*"([^"]+)"/);
    var colorMatch = html.match(/inkColor\s*:\s*'([^']+)'/);

    var metadata = {
      blankImageUrl: blankMatch ? blankMatch[1] : entry.image,
      inkColor: colorMatch ? colorMatch[1] : '#ffffff'
    };

    this.state.d20Metadata[entry.productHandle] = metadata;
    return metadata;
  };

  DiceKitBuilder.prototype.createCustomizerState = function (index, metadata, family) {
    var key = 'kit-builder-' + this.sectionId + '-d20-' + (index + 1);
    window.savedDiceFiles[key] = {
      mockupFile: null,
      engraving: null
    };

    return {
      diceFilesKey: key,
      family: family,
      isConfigured: false,
      previewUrl: metadata.blankImageUrl,
      metadata: metadata
    };
  };

  DiceKitBuilder.prototype.renderCustomizerMarkup = function (customizer, index, metadata) {
    metadata = metadata || customizer.metadata || {};

    var optionButtons = Object.keys(this.config.markups).map(function (key) {
      var markup = this.config.markups[key];
      return [
        '<button type="button" class="wizard__choice" data-engraving-choice="' + escapeHtml(key) + '">',
        '  <span class="wizard__choice-stack">',
        '    <img class="wizard__choice-preview" src="' + escapeHtml(this.config.blankDieIcon) + '" alt="Blank d20">',
        '    <img class="wizard__choice-overlay" src="' + escapeHtml(markup.small) + '" alt="' + escapeHtml(markup.label) + '">',
        '  </span>',
        '  <span class="wizard__choice-label">' + escapeHtml(markup.label) + '</span>',
        '</button>'
      ].join('');
    }, this);

    optionButtons.unshift(
      '<button type="button" class="wizard__choice" data-custom-text-toggle>' +
        '<span class="wizard__choice-stack"><img class="wizard__choice-preview" src="' + escapeHtml(this.config.blankDieIcon) + '" alt="Blank d20"></span>' +
        '<span class="wizard__choice-label">Custom text</span>' +
      '</button>'
    );
    optionButtons.unshift(
      '<button type="button" class="wizard__choice" data-custom-image>' +
        '<span class="wizard__choice-stack"><img class="wizard__choice-preview" src="' + escapeHtml(this.config.blankDieIcon) + '" alt="Blank d20"></span>' +
        '<span class="wizard__choice-label">Upload image</span>' +
      '</button>'
    );

    return [
      '<div class="wizard__customizer" data-customizer-index="' + escapeHtml(index) + '">',
      '  <div class="wizard__customizer-header">',
      '    <div>',
      '      <h3 class="wizard__customizer-title">Customize d20 #' + escapeHtml(index + 1) + '</h3>',
      '      <p class="wizard__small-note">Colorway: ' + escapeHtml(customizer.family) + '</p>',
      '      <p class="wizard__engraving-help">Choose a stock icon, upload your own image, or create up to 4 characters of custom text.</p>',
      '    </div>',
      '    <span class="wizard__status' + (customizer.isConfigured ? ' is-complete' : '') + '" data-role="customizer-status">' + (customizer.isConfigured ? 'Configured' : 'Required') + '</span>',
      '  </div>',
      '  <div class="wizard__customizer-body">',
      '    <div class="wizard__preview-frame">',
      '      <img src="' + escapeHtml(customizer.previewUrl || metadata.blankImageUrl || this.config.blankDieIcon) + '" alt="D20 preview" data-role="customizer-preview">',
      '    </div>',
      '    <div>',
      '      <div class="wizard__choice-grid">' + optionButtons.join('') + '</div>',
      '      <div class="wizard__custom-text hidden" data-role="custom-text-panel">',
      '        <div class="wizard__custom-text-fields">',
      '          <input class="wizard__select" type="text" maxlength="4" placeholder="Your text" data-role="custom-text-input">',
      '          <select class="wizard__select" data-role="custom-font">',
      '            <option>CAT Walzhari</option>',
      '            <option>Arial Black</option>',
      '            <option>Trebuchet MS</option>',
      '            <option>Times New Roman</option>',
      '            <option>Georgia</option>',
      '            <option>Immortal</option>',
      '            <option>Copperplate</option>',
      '            <option>HVD Comic Serif Pro</option>',
      '          </select>',
      '          <button type="button" class="button button--secondary" data-role="custom-text-save">Save</button>',
      '        </div>',
      '        <div class="wizard__custom-text-preview">',
      '          <img class="hidden" src="" alt="Custom text preview" data-role="custom-text-preview">',
      '          <p class="wizard__helper">Preview your custom text, then save it to attach the engraving to this die.</p>',
      '        </div>',
      '      </div>',
      '    </div>',
      '  </div>',
      '</div>'
    ].join('');
  };

  DiceKitBuilder.prototype.hydrateCustomizer = function (customizer, index, metadata) {
    var card = this.root.querySelector('[data-customizer-index="' + index + '"]');
    if (!card) {
      return;
    }

    var status = card.querySelector('[data-role="customizer-status"]');
    var previewImage = card.querySelector('[data-role="customizer-preview"]');
    var customTextPanel = card.querySelector('[data-role="custom-text-panel"]');
    var customTextInput = card.querySelector('[data-role="custom-text-input"]');
    var customFont = card.querySelector('[data-role="custom-font"]');
    var customTextPreview = card.querySelector('[data-role="custom-text-preview"]');
    var customTextSave = card.querySelector('[data-role="custom-text-save"]');

    customizer.inkColor = metadata.inkColor;
    customizer.listElement = card;
    customizer.productBackgroundImage = previewImage;
    customizer.product = metadata.blankImageUrl;
    customizer.blank = this.config.blankDieIcon;
    customizer.customFont = customFont;
    customizer.customTextMsg = customTextInput;
    customizer.customTextRender = customTextPreview;
    customizer.customTextAccept = customTextSave;
    customizer.mockupImageName = customizer.diceFilesKey + '-mockup.png';
    customizer.engravingImageFile = customizer.diceFilesKey + '-engraving.png';
    customizer.defaultMarkups = this.config.markups;
    customizer.previewUrl = customizer.previewUrl || metadata.blankImageUrl;
    customizer.productBackgroundImage.src = customizer.previewUrl;
    customizer.updateComplete = function () {
      customizer.isConfigured = true;
      customizer.previewUrl = customizer.productBackgroundImage.src;
      status.textContent = 'Configured';
      status.classList.add('is-complete');
      customTextPanel.classList.add('hidden');
      this.state.errorMessage = '';
      this.renderAll();
    }.bind(this);

    Object.keys(D20_LAYOUT).forEach(function (key) {
      customizer[key] = D20_LAYOUT[key];
    });

    customTextInput.addEventListener('keyup', function () {
      renderCustomText(customizer);
    });

    customFont.addEventListener('change', function () {
      renderCustomText(customizer);
    });

    customTextSave.addEventListener('click', function () {
      if (!customTextInput.value.trim()) {
        return;
      }
      customizer.engravingChoice = null;
      customizer.customTextValue = customTextInput.value.trim();
      customizer.customFontValue = customFont.options[customFont.selectedIndex].text;
      renderAndStoreCustomText(customizer);
    });

    Array.prototype.forEach.call(card.querySelectorAll('[data-engraving-choice]'), function (button) {
      button.addEventListener('click', function () {
        customizer.engravingChoice = button.getAttribute('data-engraving-choice');
        customizer.customTextValue = null;
        customizer.customFontValue = null;
        stockElementClick(customizer, button.getAttribute('data-engraving-choice'));
      });
    });

    var customTextButton = card.querySelector('[data-custom-text-toggle]');
    if (customTextButton) {
      customTextButton.addEventListener('click', function () {
        customTextPanel.classList.toggle('hidden');
        if (!customTextPanel.classList.contains('hidden')) {
          customTextInput.focus();
          renderCustomText(customizer);
        }
      });
    }

    var customImageButton = card.querySelector('[data-custom-image]');
    if (customImageButton) {
      customImageButton.addEventListener('click', function () {
        customizer.engravingChoice = null;
        customizer.customTextValue = null;
        customizer.customFontValue = null;
        this.handleCustomImageUpload(customizer);
      }.bind(this));
    }

    if (customizer.isConfigured) {
      status.textContent = 'Configured';
      status.classList.add('is-complete');
    }
  };

  DiceKitBuilder.prototype.handleCustomImageUpload = function (customizer) {
    var input = document.createElement('input');
    input.type = 'file';
    input.accept = 'image/*';
    input.addEventListener('change', function () {
      if (!input.files || !input.files[0]) {
        return;
      }

      var original = new MarvinImage();
      var reader = new FileReader();
      reader.addEventListener('load', function () {
        original.load(reader.result, function () {
          processCustomEngraving(customizer, original);
        });
      });
      reader.readAsDataURL(input.files[0]);
    });
    input.click();
  };

  DiceKitBuilder.prototype.serializeRecipe = function () {
    var compact = {};
    FACE_ORDER.forEach(function (face) {
      if (this.state.slotSelections[face] && this.state.slotSelections[face].length) {
        compact[face] = this.state.slotSelections[face].slice();
      }
    }, this);
    if (this.state.preset) {
      compact.preset = this.state.preset;
    }
    return JSON.stringify(compact);
  };

  DiceKitBuilder.prototype.buildCartRequests = function () {
    var selectedSlots = this.getSelectedSlots();
    var kitId = 'kit-' + Date.now() + '-' + Math.random().toString(36).slice(2, 8);
    var kitName = this.buildKitName();
    var recipe = this.serializeRecipe();
    var requests = [];
    var groupedRequests = {};

    selectedSlots.forEach(function (slot) {
      if (slot.face === 'd20') {
        requests.push({
          variantId: slot.entry.variantId,
          quantity: 1,
          properties: {
            Kit: kitName,
            Die: slot.slotLabel,
            Colorway: slot.family,
            _kit_id: kitId,
            _kit_face: slot.face,
            _kit_slot: slot.face + '-' + (slot.slotIndex + 1),
            _kit_recipe: recipe
          },
          lineLabel: slot.slotLabel + ' — ' + slot.family,
          customizerKey: this.state.customizers[slot.slotIndex].diceFilesKey
        });
        return;
      }

      var groupKey = slot.entry.variantId;
      if (!groupedRequests[groupKey]) {
        groupedRequests[groupKey] = {
          variantId: slot.entry.variantId,
          quantity: 0,
          properties: {
            Kit: kitName,
            Die: FACE_LABELS[slot.face],
            Colorway: slot.family,
            _kit_id: kitId,
            _kit_face: slot.face,
            _kit_slot: slot.face + '-' + slugify(slot.family),
            _kit_recipe: recipe
          },
          lineLabel: FACE_LABELS[slot.face] + ' — ' + slot.family
        };
      }

      groupedRequests[groupKey].quantity += 1;
      groupedRequests[groupKey].lineLabel = FACE_LABELS[slot.face] + ' — ' + slot.family + ' × ' + groupedRequests[groupKey].quantity;
    }, this);

    Object.keys(groupedRequests).forEach(function (groupKey) {
      requests.push(groupedRequests[groupKey]);
    });

    if (this.state.vaultEnabled) {
      var vaultProduct = this.getSelectedVaultProduct();
      var vaultVariant = vaultProduct ? vaultProduct.variants.find(function (variant) {
        return String(variant.id) === String(this.state.vaultVariantId);
      }, this) : null;

      if (vaultProduct && vaultVariant) {
        requests.push({
          variantId: String(vaultVariant.id),
          quantity: 1,
          properties: {
            Kit: kitName,
            Accessory: 'Dice Vault',
            _kit_id: kitId,
            _kit_face: 'vault',
            _kit_slot: 'vault',
            _kit_recipe: recipe
          },
          lineLabel: 'Dice Vault'
        });
      }
    }

    return requests;
  };

  DiceKitBuilder.prototype.addKitToCart = async function (goToCheckout) {
    if (this.state.busy) {
      return;
    }

    var selectedSlots = this.getSelectedSlots();
    if (!selectedSlots.length) {
      this.state.errorMessage = 'Choose at least one die before adding your kit to the cart.';
      this.renderAll();
      return;
    }

    if (this.state.slotSelections.d20.length !== this.state.customizers.length) {
      this.state.errorMessage = 'Please wait for the d20 customization options to finish loading.';
      this.renderAll();
      return;
    }

    var pendingCustomizations = this.state.customizers.filter(function (customizer) {
      return !customizer.isConfigured;
    }).length;

    if (pendingCustomizations) {
      this.state.errorMessage = 'Finish customizing every d20 before adding your kit to the cart.';
      this.renderAll();
      return;
    }

    this.state.busy = true;
    this.state.errorMessage = '';
    this.state.infoMessage = '';
    this.renderAll();

    var requests = this.buildCartRequests();
    var successfulAdds = 0;

    try {
      for (var index = 0; index < requests.length; index += 1) {
        try {
          await this.postCartRequest(requests[index]);
        } catch (error) {
          throw new Error((requests[index].lineLabel || 'One kit item') + ' could not be added. ' + error.message);
        }
        successfulAdds += 1;
      }
      clearStateFromStorage();
      window.removeEventListener('beforeunload', this._beforeUnloadHandler);
      window.location.href = goToCheckout ? '/checkout' : this.config.cartUrl;
    } catch (error) {
      this.state.errorMessage = successfulAdds ? (error.message + ' Some items may already be in your cart, so please review it before trying again.') : error.message;
      this.renderAll();
    } finally {
      this.state.busy = false;
      this.renderAll();
    }
  };

  DiceKitBuilder.prototype.postCartRequest = async function (request) {
    var formData = new FormData();
    formData.append('id', request.variantId);
    formData.append('quantity', request.quantity);

    Object.keys(request.properties || {}).forEach(function (key) {
      formData.append('properties[' + key + ']', request.properties[key]);
    });

    if (request.customizerKey) {
      var files = window.savedDiceFiles[request.customizerKey];
      if (!files || !files.mockupFile || !files.engraving) {
        throw new Error('A d20 in this kit is missing its engraving configuration.');
      }
      formData.append('properties[design-1]', files.mockupFile);
      formData.append('properties[_engravingFile-1]', files.engraving);
    }

    var response = await fetch((window.routes && window.routes.cart_add_url) || '/cart/add', {
      method: 'POST',
      headers: {
        'X-Requested-With': 'XMLHttpRequest',
        'Accept': 'application/json'
      },
      body: formData
    });
    var payload = await response.json();

    if (!response.ok || payload.status) {
      throw new Error(payload.description || 'Something went wrong while adding your kit to the cart.');
    }

    return payload;
  };

  DiceKitBuilder.prototype.syncVaultVariantSelection = function () {
    var selectedProduct = this.getSelectedVaultProduct();
    if (selectedProduct && selectedProduct.variants.length) {
      this.state.vaultVariantId = String(selectedProduct.variants[0].id);
    }
  };

  DiceKitBuilder.prototype.getSelectedVaultProduct = function () {
    return this.vaultProducts.find(function (product) {
      return product.handle === this.state.vaultProductHandle;
    }, this) || null;
  };

  document.addEventListener('DOMContentLoaded', function () {
    Array.prototype.forEach.call(document.querySelectorAll('[data-dice-kit-builder]'), function (element) {
      var builder = new DiceKitBuilder(element);
      builder.init();
    });
  });
})();
